export const calculateDepartmentViews = (departments: any, field: any) => {
    return departments.map((department: any) => {
        const totalViews = field
            .filter((article: any) => article.department_id === department._id)
            .reduce((acc: any, article: any) => acc + article.views, 0);

        return {
            name: department.name,
            value: totalViews,
        };
    });
};
